export const onDialogExited = dialogType => ({
  widget: 'models',
  type: 'onDialogExited',
  payload: { dialogType },
})



// WEBPACK FOOTER //
// ./src/models/actions/onDialogExited.js